import { AgGridReact } from 'ag-grid-react';
import { useCallback, useMemo, useRef, useState } from 'react';
import {
  getAccountList,
  getContactList,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getLeadList,
  getOpportunityList,
} from '../../redux/selector';
import { fetchCampaignsAndAppendToModule } from '../../redux/actions';
import arrowright from '../../assets/img/leadsform/arrowright.svg';
import arrowleft from '../../assets/img/leadsform/arrowleft.svg';
import { useDispatch, useSelector } from 'react-redux';
import apiServices from '../../services/service';
import { DateFormatter } from '../../shared/controls/formatters';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';

const ChildDeal = ({ module, localData, hasUpdateOpportunityPermission }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredCampaignList, setFilteredCampaignList] = useState([]);
  const [editData, setEditData] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  const gridRef = useRef();
  const localGridRef = useRef();
  const gridData = useSelector(getGridDataByModuleKey('opportunityList'));

  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  let hasInfoOpportunityPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.opportunitymenu;

  if (userUIControlPermission) {
    hasInfoOpportunityPermission = userUIControlPermission?.opportunityinfoscreen
      ? userUIControlPermission.opportunityinfoscreen.canView
      : true;
  }

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const campaignColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: '',
      maxWidth: 50,
      suppressSizeToFit: true,
    },
    { headerName: 'Campaign Name', field: 'campaignName', width: 150 },
    { headerName: 'Status', field: 'status', width: 150 },
    { headerName: 'Source', field: 'campaignType', width: 150 },
    { headerName: 'Start Date', field: 'startDate', width: 150, valueFormatter: DateFormatter },
    { headerName: 'End Date', field: 'endDate', width: 150, valueFormatter: DateFormatter },
    { headerName: 'Owner', field: 'owner', width: 150 },
  ];

  const localCampaignColumnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            {hasUpdateOpportunityPermission && (
              <img
                src="/assets/images/edit.png"
                className="action-img1"
                onClick={() => handleClickEdit(paramsValue)}
                alt="Edit Opportunity"
                title="Edit Opportunity"
              ></img>
            )}
          </div>
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    {
      headerName: 'Opportunity Name',
      field: 'name',
      width: 150,
      filter: 'agSetColumnFilter',
      cellRenderer: (params) => {
        if (!params.value) return null;

        return hasInfoOpportunityPermission ? (
          <Link
            to={`/opportunity/viewOpportunity?${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
            state={params.data}
            style={{ fontWeight: '600' }}
          >
            {params.value}
          </Link>
        ) : (
          <span style={{ fontWeight: '600' }}>{params.value}</span>
        );
      },
    },
    { headerName: 'Account Name', field: 'account', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Contact Name', field: 'contact', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Stage', field: 'stage', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Industry', field: 'industry', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Lead Source', field: 'leadSource', width: 150, filter: 'agSetColumnFilter' },
    { headerName: 'Source Name', field: 'sourceName', width: 150, filter: 'agSetColumnFilter' },
    {
      headerName: 'Line Of Business',
      field: 'lineOfBusiness',
      width: 150,
      filter: 'agSetColumnFilter',
    },
  ];

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);
  const viewCampaign = (params) => {
    alert(`Viewing campaign: ${params.data.campaignName}`);
  };

  const editCampaign = (params) => {
    alert(`Editing campaign: ${params.data.campaignName}`);
  };

  const deleteCampaign = (params) => {
    alert(`Deleting campaign: ${params.data.campaignName}`);
  };

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };
  const navigate = useNavigate();

  const handleOpenOpportunityAdd = () => {
    navigate('/opportunity/addOpportunity',{
    state: { from: module } 
  });
  };
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closePopup3 = () => {
    setShowPopup3(false);
  };

  // Function to open the third popup
  const openPopup3 = (data) => {
    setShowPopup3(true);
    setDeleteData(data);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  const handleSubmit = async (formData) => {
    const selectedIds = selectedRows.map((row) => row.id);

    // Define module-specific API services and dynamic key for leadId
    const moduleAPIs = {
      Lead: {
        add: apiServices.addCampaignFromLead,
        edit: apiServices.updateCampaignByModule,
        leadKey: 'leadId', // The key for Lead module
        leadValue: localData?.id, // The value for Lead module
      },
      Contact: {
        add: apiServices.addCampaignFromContact,
        edit: apiServices.updateCampaignByModule,
        leadKey: 'contactId', // The key for Contact module
        leadValue: localData?.id, // The value for Contact module
      },
      Account: {
        add: apiServices.addCampaignFromAccount,
        edit: apiServices.updateCampaignByModule,
        leadKey: 'accountId', // The key for Account module
        leadValue: localData?.id, // The value for Account module
      },
      Opportunity: {
        add: apiServices.addCampaignFromOpportunity,
        edit: apiServices.updateCampaignByModule,
        leadKey: 'opportunityId', // The key for Opportunity module
        leadValue: localData?.id, // The value for Opportunity module
      },
    };

    // Select the API based on the module and form type
    const selectedAPI =
      formData?.type === 'edit' ? moduleAPIs[module]?.edit : moduleAPIs[module]?.add;

    const leadKey = moduleAPIs[module]?.leadKey;
    const leadValue = moduleAPIs[module]?.leadValue;

    if (!selectedAPI || !leadKey || !leadValue) {
      toast.error('Invalid module or operation type.', {
        position: 'top-right',
      });
      return;
    }

    // Prepare the updated form data
    const updatedFormData = {
      ...formData,
      campaignId: formData?.type === 'edit' ? formData?.id : selectedIds,
      [leadKey]: [leadValue], // Dynamically set the correct leadId key based on the module
      module: module,
      moduleId: localData?.id,
    };

    setLoading(true);

    try {
      const response = await selectedAPI(updatedFormData);
      if (response.status === 200) {
        if (formData?.type !== 'edit') handleClose();
        else setShowPopup2(false);

        dispatch(
          fetchCampaignsAndAppendToModule({
            moduleName: module,
            id: localData?.id,
          })
        );

        toast.success('Campaign updated successfully!', {
          position: 'top-right',
        });
      } else {
        const errorMessages = Object.values(response.errors || {}).flat();
        errorMessages.forEach((errorMessage) =>
          toast.error(errorMessage, { position: 'top-right' })
        );
      }
    } catch (error) {
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClickDeleteCampaign = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      campaignId: paramsValue.id,
      module: module,
      moduleId: localData.id,
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          setShowPopup3(false);
          dispatch(
            fetchCampaignsAndAppendToModule({
              moduleName: module,
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Campaign Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
      });
  };

  const handleClickEdit = (data) => {
    navigate('/opportunity/editOpportunity', {
      state: { ...data, type: 'edit' },
    });
  };

  const handleEditOpportunity = () => {};
  return (
    <div className="row" id="campainview">
      <div className="col-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/dealIcon.svg" alt="" />
              Opportunities({localData?.opportunity?.length})
            </label>
            {hasUpdateOpportunityPermission && (
              <button
                type="button"
                className="btn btn-outline-primary attBtn"
                onClick={handleOpenOpportunityAdd}
              >
                Add Opportunity
              </button>
            )}
          </div>
          <div className="leadcontent" style={{ pointerEvents: 'unset' }}>
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <div id="view_leadtable">
                    <div className="heading_item">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                    <div className="cutome_ag_theme " style={{ marginTop: '1rem' }} id="withFilter">
                      <div className="ag-theme-balham tbl_height">
                        <AgGridReact
                          rowData={localData?.opportunity}
                          columnDefs={localCampaignColumnDefs}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          rowSelection="multiple"
                          sideBar={sideBar}
                          alwaysShowVerticalScroll={true}
                          ref={localGridRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
        {/* Modal structure Add To Campaigns */}
        {/* Popup */}
        {isOpen && (
          <div className="popup-backdrop">
            <div className="popup">
              {/* Popup Header */}
              <div className="popup-header">
                <h4 className="popup-title">
                  Add Campaigns to Lead : {localData.firstName} {localData.middleName}{' '}
                  {localData.lastName}
                </h4>
                <button className="view-close" onClick={handleClose}>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693274 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM20.055 21.8L16 17.745L11.945 21.8C11.8318 21.9186 11.6961 22.0135 11.5457 22.0789C11.3954 22.1443 11.2335 22.179 11.0695 22.1809C10.9056 22.1828 10.7429 22.152 10.591 22.0901C10.4392 22.0283 10.3012 21.9367 10.1853 21.8207C10.0693 21.7048 9.97775 21.5668 9.9159 21.415C9.85404 21.2631 9.82317 21.1005 9.8251 20.9365C9.82704 20.7725 9.86173 20.6106 9.92714 20.4603C9.99255 20.3099 10.0874 20.1742 10.206 20.061L14.261 16.006L10.206 11.951C9.9843 11.7186 9.8623 11.4087 9.86608 11.0875C9.86986 10.7663 9.99913 10.4594 10.2263 10.2322C10.4534 10.0051 10.7603 9.87586 11.0815 9.87207C11.4027 9.86829 11.7126 9.99029 11.945 10.212L16 14.267L20.055 10.212C20.2874 9.99029 20.5973 9.86829 20.9185 9.87207C21.2397 9.87586 21.5466 10.0051 21.7738 10.2322C22.0009 10.4594 22.1301 10.7663 22.1339 11.0875C22.1377 11.4087 22.0157 11.7186 21.794 11.951L17.739 16.006L21.794 20.061C22.0233 20.2923 22.152 20.6048 22.152 20.9305C22.152 21.2562 22.0233 21.5687 21.794 21.8C21.6802 21.915 21.5447 22.0063 21.3953 22.0685C21.2459 22.1307 21.0857 22.1626 20.9239 22.1623C20.7621 22.162 20.6019 22.1296 20.4528 22.0669C20.3036 22.0042 20.1684 21.9124 20.055 21.797V21.8Z"
                      fill="#456ABB"
                    />
                  </svg>
                </button>
              </div>
              {/* Popup Body */}
              <div className="popup-body">
                <div className="popupbody_header">
                  <div className="hd_leftview">
                    <div className="timetrack_searcharea">
                      <input
                        type="text"
                        id="filter-text-box"
                        className="search_field"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChanged}
                      />
                      <i className="icon_tt"></i>
                    </div>

                    <div className="flx_heding view_fnt" id="action_dropdown">
                      <>
                        <label htmlFor="memberStatusId" style={{ width: '100px' }}>
                          Member Status:
                        </label>
                        <Select
                          value={selectedOptions.memberStatus}
                          placeholder={formData.memberStatusId}
                          onChange={(selectedOption) =>
                            handleChange(selectedOption, 'memberStatusId')
                          }
                          options={memberStatus?.map((data) => ({
                            value: data.id,
                            label: data.displayName,
                          }))}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: '200px',
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: '9999',
                              height: '200px',
                              overflow: 'auto',
                              color: '#000',
                            }),
                            control: (base) => ({
                              ...base,
                              borderRadius: '50px',
                            }),
                          }}
                        />
                      </>
                    </div>
                  </div>
                  <div className="hd_rightview" id="update_campaign">
                    <div className="flx_heding view_fnt">
                      <label>
                        Total Records: <span>{filteredCampaignList.length}</span>
                      </label>
                    </div>
                    <span className="separator"></span>

                    <div className="flx_heding view_fnt">
                      <label
                        style={{
                          minWidth: '100px',
                          display: 'inline-block',
                        }}
                      >
                        Result per page:
                        <span></span>
                      </label>
                      <div className="dropdown" id="page_dropdown">
                        <button
                          className=" action-btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          10
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li>
                            <Link className="dropdown-item" href="#">
                              50
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" href="#">
                              100
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <span className="separator"></span>

                    <div className="flx_heding view_fnt view_num">
                      <label>1-10</label>
                      <div className="d-flex align-items-center gap-2">
                        <Link>
                          <img src={arrowleft} alt="arrow" />
                        </Link>
                        <Link>
                          <img src={arrowright} alt="arrow" />
                        </Link>
                      </div>
                    </div>
                    <span className="separator"></span>
                    <div className="flx_heding">
                      <button
                        className="add-btn"
                        type="button"
                        onClick={() => handleSubmit(formData)}
                        disabled={!selectedRows.length > 0}
                      >
                        Add to {module}
                      </button>
                    </div>

                    {/* Popup 2 Overlay */}
                  </div>
                </div>
                <div id="view_leadtable">
                  <div
                    className="ag-theme-balham"
                    style={{
                      height: 178,
                      width: '100%',
                      margin: '1rem auto',
                      backgroundColor: 'white',
                      border: '1px solid #ccc',
                      borderRadius: '10px',
                    }}
                  >
                    <AgGridReact
                      rowData={filteredCampaignList}
                      columnDefs={campaignColumnDefs}
                      frameworkComponents={frameworkComponents}
                      defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                        resizable: true,
                      }}
                      rowSelection="multiple"
                      onSelectionChanged={onSelectionChanged}
                      ref={gridRef}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showPopup2 && (
          <div className="popup-backdrop">
            <div className="popup-overlay">
              <div className="popup" style={{ width: '50%' }}>
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">Update Campaign Member Status</h4>
                  <button className="close-btn" onClick={closePopup2}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693274 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM20.055 21.8L16 17.745L11.945 21.8C11.8318 21.9186 11.6961 22.0135 11.5457 22.0789C11.3954 22.1443 11.2335 22.179 11.0695 22.1809C10.9056 22.1828 10.7429 22.152 10.591 22.0901C10.4392 22.0283 10.3012 21.9367 10.1853 21.8207C10.0693 21.7048 9.97775 21.5668 9.9159 21.415C9.85404 21.2631 9.82317 21.1005 9.8251 20.9365C9.82704 20.7725 9.86173 20.6106 9.92714 20.4603C9.99255 20.3099 10.0874 20.1742 10.206 20.061L14.261 16.006L10.206 11.951C9.9843 11.7186 9.8623 11.4087 9.86608 11.0875C9.86986 10.7663 9.99913 10.4594 10.2263 10.2322C10.4534 10.0051 10.7603 9.87586 11.0815 9.87207C11.4027 9.86829 11.7126 9.99029 11.945 10.212L16 14.267L20.055 10.212C20.2874 9.99029 20.5973 9.86829 20.9185 9.87207C21.2397 9.87586 21.5466 10.0051 21.7738 10.2322C22.0009 10.4594 22.1301 10.7663 22.1339 11.0875C22.1377 11.4087 22.0157 11.7186 21.794 11.951L17.739 16.006L21.794 20.061C22.0233 20.2923 22.152 20.6048 22.152 20.9305C22.152 21.2562 22.0233 21.5687 21.794 21.8C21.6802 21.915 21.5447 22.0063 21.3953 22.0685C21.2459 22.1307 21.0857 22.1626 20.9239 22.1623C20.7621 22.162 20.6019 22.1296 20.4528 22.0669C20.3036 22.0042 20.1684 21.9124 20.055 21.797V21.8Z"
                        fill="#456ABB"
                      />
                    </svg>
                  </button>
                </div>

                {/* Popup Body */}
                <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="input-container">
                        <>
                          <label htmlFor="memberStatusId">Member Status</label>
                          <Select
                            value={selectedOptions.memberStatusId}
                            placeholder={editData.memberStatus || 'Select Status'}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, 'memberStatusId')
                            }
                            options={memberStatus?.map((data) => ({
                              value: data.id,
                              label: data.displayName,
                            }))}
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: '100%',
                                zIndex: '9999',
                              }),
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                border: state.isFocused ? '2px solid #365397' : '1px solid #ccc',
                                boxShadow: state.isFocused ? '0 0 5px #365397' : 'none', // Focus shadow
                                transition: 'border-color 0.3s, box-shadow 0.3s',
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: '99999', // Dropdown z-index
                                maxHeight: '150px', // Limit dropdown height
                                overflowY: 'auto', // Scroll if items exceed height
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: '99999', // Rendered dropdown above everything
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused
                                  ? '#365397' // Hover background
                                  : state.isSelected
                                    ? 'rgba(54, 83, 151, 0.2)' // Selected background
                                    : '#fff', // Default background
                                color: state.isFocused || state.isSelected ? '#fff' : '#000', // Text color
                                cursor: 'pointer',
                                transition: 'background-color 0.3s, color 0.3s',
                              }),
                              singleValue: (base) => ({
                                ...base,
                                padding: '5px',
                                borderRadius: '3px',
                              }),
                            }}
                          />
                        </>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Popup Footer */}
                <div className="popup-footer" id="unassign-popup">
                  <button className="cancel-lead ld-btn" onClick={closePopup2}>
                    Cancel
                  </button>
                  <button
                    className="save-lead ld-btn"
                    onClick={() => handleSubmit({ ...formData, id: editData.id, type: 'edit' })}
                  >
                    Save
                  </button>

                  {/* Popup 3 Overlay */}
                </div>
              </div>
            </div>
          </div>
        )}
        {showPopup3 && (
          <div id="unassign-popup">
            <div className="popup-overlay">
              <div
                className="popup"
                style={{
                  width: '50%',
                  textAlign: 'center',
                  padding: '20px',
                  zIndex: '9999',
                  background: 'white',
                }}
              >
                {/* Popup Body */}
                <div className="popup-body">
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="unassign-txt">
                        <p>
                          Unassign {deleteData.campaignName} from {localData.firstName}{' '}
                          {localData.middleName} {localData.lastName}?
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Popup Footer */}
                <div className="unassign-footer">
                  <button className="cancel-lead ld-btn" onClick={closePopup3}>
                    Cancel
                  </button>
                  <button
                    className="unassign-lead ld-btn"
                    onClick={() => handleClickDeleteCampaign(deleteData)}
                  >
                    Unassign
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChildDeal;
